module.exports = __webpack_public_path__ + "static/media/banner_bg.777d7327.jpg";